<template>
  <v-container class="mt-1" fluid pa-0 ma-0>
    <div v-if='error' class='error'>
      {{ error }}
    </div>

    <v-form ref="search" @submit="search" mt3>
      <v-layout row wrap ma-2>
        <v-flex xs12 sm8 offset-sm2 class="text-xs-left" v-if="!isLoggedIn">
            <v-btn :loading="!isLoaded" :disabled="!isLoaded" @click="twitchLogin" color="purple">Login
              <template v-slot:loader>
                <span class="custom-loader">
                  <v-icon>mdi-cached</v-icon>
                </span>
              </template>
            </v-btn>
        </v-flex>

        <v-flex xs12 sm8 class="text-xs-left" v-if="isLoggedIn">
          <div class="pa-1">Logged in.</div>
        </v-flex>
      </v-layout>
      <v-layout row wrap justify-center ma-2>
        <v-flex xs12 sm3 offset-sm1>
          <v-text-field v-model="user" label="Username" required :rules="nameRules" clearable></v-text-field>
          <!-- <v-select :items="games" item-text='name' item-value='id' label="Games Filter" v-model="selectedGame" multiple clearable></v-select> -->
<!--           <v-select :items="authors" label="Author Filter" v-model="selectedAuthors" multiple clearable>
            <template v-slot:prepend-item>
              <v-list-item ripple @click="selectAllAuthorsToggle">
                <v-list-item-action>
                  <v-icon :color="selectedAuthors.length > 0 ? 'accent' : ''">{{ selectedAuthorsIcon }}</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-tile-title>Select All</v-list-tile-title>
                </v-list-item-content>
              </v-list-item>
              <v-divider class="mt-2"></v-divider>
            </template>
          </v-select> -->
        </v-flex>
        <v-flex xs12 sm3 offset-sm1>
<!--           <v-radio-group v-model="useSearchGrid" @change="persist">
            <v-radio label="Thumbnail Grid" :value="true"></v-radio>
            <v-radio label="Data Table" :value="false"></v-radio>
          </v-radio-group> -->
          <v-checkbox label="Use Twitch Player" v-model="useTwitchPlayer" @change="persist" v-if="useSearchGrid" />
          <v-checkbox label="Batch Search" v-model="batchSearch" @change="persist" hint="Batch API search calls to 30 days. Slower but more reliable." class="mb-5" persistent-hint />
          <v-select :items="broadcastTypes" v-model="selectedBroadcastType" label="Video Type"></v-select>
          <v-select :items="exportTypes" v-model="selectedExportType" label="Export Type"></v-select>
          <v-btn class="ma-1" @click="exportData">Export Data</v-btn>
        </v-flex>
      </v-layout>
      <v-layout>
        <v-flex xs12 sm8 offset-sm2 class="text-xs-center">
            <v-btn :loading="!isLoaded" :disabled="!isLoaded || !isLoggedIn" type="submit" color="purple">Search
              <template v-slot:loader>
                <span class="custom-loader">
                  <v-icon>mdi-cached</v-icon>
                </span>
              </template>
            </v-btn>
        </v-flex>
      </v-layout>
    </v-form>

    <v-layout row wrap justify-center>
      <v-flex xs12 sm3 offset-sm1 pl-2>
        <div class="pa-1">Total Videos: {{this.videos.length}}</div>
        <div class="pa-1">Videos Filtered: {{this.videosFiltered.length}}</div>
      </v-flex>
    </v-layout>
    
    <v-container fluid v-if="!useSearchGrid" pa-0 ma-0>
      <v-layout row wrap justify-center>
        <v-flex xs12 sm3 offset-sm1 class="mb-2">
          <v-text-field v-model="filter" append-icon="mdi-magnify" label="Filter" single-line hide-details clearable />
        </v-flex>
      </v-layout>
      <v-layout row wrap justify-center>
        <v-flex xs12 lg8>
          <v-data-table :show-select="showSelect" :headers="headers" :items="videosFiltered" :loading="!isLoaded" :must-sort="true" :sort-by.sync="sortByField" :sort-desc.sync="sortDescending" :footer-props="{itemsPerPageOptions:[100,200,-1]}" :search="filter" class="elevation-1" show-selec>
            <v-progress-linear v-slot:progress color="purple" indeterminate></v-progress-linear>

            <template v-slot:item.preview="{ item }">
                  <a v-on:click="previewPlay(item.id)"><v-img width="12vw" :src="item.thumbnail_url" /></a>
            </template>

            <template v-slot:item.links="{ item }">
                <!-- <v-btn text icon color="purple lighten-2" :href="item.download_url" pa-0 ma-0><v-icon size="18px">fa fa-download</v-icon></v-btn> -->
                <v-btn text icon color="purple lighten-2" :href="item.url" pa-0 ma-0><v-icon size="18px">fab fa-twitch</v-icon></v-btn>
            </template>

            <v-alert v-slot:no-results :value="true" color="error" icon="warning">
              Your search for "{{ search }}" found no results.
            </v-alert>
          </v-data-table>
        </v-flex>
      </v-layout>
    </v-container>

    <v-container fluid grid-list-lg v-if="useSearchGrid">
      <v-layout justify-center v-if="pages>1">
        <v-flex shrink>
          <v-card>
            <v-card-text>
              <v-pagination
                v-model="page"
                :length="pages"
                :total-visible="10"
              ></v-pagination>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
      <v-layout row wrap>
          <!-- <twitch-clip v-for='clip in clipsPage' :key='clip.id' :clip='clip' :twitchPlayer="useTwitchPlayer" /> -->
      </v-layout>
    </v-container>
  </v-container>
</template>

<script>
//import TwitchClip from '@/components/TwitchClip'
import TwitchWrapper from '@/TwitchWrapper'
import dayjs from 'dayjs'
import {parse as json2csv} from 'json2csv'

export default {
  name: 'TwitchVideoSearch',
  components: {
    //TwitchClip
  },
  computed: {
    allAuthorsSelected () {
      return this.selectedAuthors.length === this.authors.length
    },
    someAuthorsSelected () {
      return this.selectedAuthors.length > 0 && !this.allSelected
    },
    selectedAuthorsIcon () {
      if (this.allAuthorsSelected) return 'mdi-close-box'
      if (this.someAuthorsSelected) return 'mdi-minus-box'
      return 'mdi-checkbox-blank-outline'
    },
    pages: function () {
      return Math.ceil(this.videosFiltered.length / this.pageSize)
    },
    videosFiltered: function () {
      var data = this.videos

      if(this.selectedGame.length > 0){
        data = data.filter(v => this.selectedGame.includes(v.game.id));
      }
      if(this.selectedAuthors.length > 0){
        data = data.filter(v => this.selectedAuthors.includes(v.creator_name));
      }

      return data;
    },
    videoPage: function () {
      let currentPage = this.page
      if(currentPage > this.pages){currentPage = 1}

      return this.videosFiltered.slice((currentPage-1)*this.pageSize,currentPage*this.pageSize)
    },
  },
  data () {
    return {
      isLoaded: true,
      isLoggedIn: this.$root.$data.isLoggedIn,
      error: null,     
      filter: '',

      auth: null,

      useTwitchPlayer: localStorage.useTwitchPlayer == 0 ? false : true,
      batchSearch: localStorage.batchSearch == 0 ? false : true,
      useSearchGrid: false,

      videoUserData: localStorage.videoUserData,

      showSelect: false,
      showId: localStorage.showId == 1 ? true : false,

      user: this.$router.currentRoute.params.channelName,
      
      showPreview: false,

      selectedGame: [],
      selectedAuthors: [],

      selectedExportType: 'Links',
      exportTypes: ['Links', 'CSV', 'JSON', 'Links / 100 Batches'],

      selectedBroadcastType: 'Upload',
      broadcastTypes: ['Upload', 'Highlight', 'Archive'],

      page: 1,
      pageSize: 100,

      videos: [],
      games: [],
      authors: [],

      twitch: new TwitchWrapper(this.$root.$data.clientId),

      sortByField: 'view_count',
      sortDescending: true,

      headers: [
        { text: 'Preview', value:'thumbnail_url', align: 'left', sortable: false, value: 'preview' },
        { text: 'Title', value: 'title', align: 'left',  },
        { text: 'Game', value: 'game.name', align: 'left'},
        { text: 'Author', value: 'creator_name', align: 'left'},
        { text: 'View Count', value: 'view_count', align:'center', },
        { text: 'Created At', value: 'created_at', align:'center', },
        { text: 'Links', sortable: false, align:'center', value: 'links' },
      ],

      nameRules: [
        v => !!v || 'Username is required',
      ],
      dateToRules: [
        v => v >= this.fromDate || 'Date to search To must be less than From.',
      ],
      dateFromRules: [
        v => this.toDate >= v || 'Date to search From must be greater than To.',
      ],
    }
  },
  methods: {
    previewPlay(id) {
      var video = document.getElementById(id + '_previewVideo');
      if (video === null) {
        this.showPreview = id
      }
      else {
        video.pause()
        this.showPreview = false
      }
    },
    selectAllAuthorsToggle () {
      this.$nextTick(() => {
        if (this.allAuthorsSelected) {
          this.selectedAuthors = []
        } else {
          this.selectedAuthors = this.authors
        }
      })
    },
    randomState(){
      const validChars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
      let array = new Uint8Array(20)
      window.crypto.getRandomValues(array)
      array = array.map(x => validChars.charCodeAt(x % validChars.length))
      const randomState = String.fromCharCode.apply(null, array)
      return randomState
    },
    twitchLogin() {
      let state = this.$route.path + '_' + this.randomState()
      let url = `https://id.twitch.tv/oauth2/authorize?client_id=${this.$root.$data.clientId}&redirect_uri=${window.location.origin}/auth&response_type=token&state=${state}`
      //console.log(url)
      window.location = url
    },
    batchDownload() {
      var start = 0
      this.videosFiltered.forEach((c) => {
        setTimeout(function(){
          var url = ""
          var container = document.createElement('a')
          container.href = url
          container.click()
        }, start)
        start += 1300
      })
    },
    exportData() {
      if(this.selectedExportType == "JSON") {
        let jsnData = JSON.stringify(this.videosFiltered)
        navigator.clipboard.writeText(jsnData)
        this.downloadData(jsnData, `${this.user}_clips.json`)
      }
      if(this.selectedExportType == "CSV") {
        let fields = ['id', 'title', 'view_count', 'created_at', 'url', 'thumbnail_url']
        let csv = json2csv(this.videosFiltered, {fields})
        navigator.clipboard.writeText(csv)
        this.downloadData(csv, `${this.user}_clips.csv`)
      }
      if(this.selectedExportType == "Links") {
        let links = this.videosFiltered.map(c => c.url).join('\n')
        navigator.clipboard.writeText(links)
        this.downloadData(links, `${this.user}_clips.txt`)
      }
      if(this.selectedExportType == "Links / 100 Batches") {
        let links = this.videosFiltered.map(c => c.url)

        let c = 1
        let index = 0
        let size = 100

        while (index < links.length) {
          this.downloadData(links.slice(index, size + index).join('\n'), `Clips_${c}.txt`)
          index += size
          c++
        }
        navigator.clipboard.writeText(links)
      }
    },
    downloadData(content, filename, contentType)
    {
      if(!contentType) contentType = 'application/octet-stream';
      var a = document.createElement('a');
      var blob = new Blob([content], {'type':contentType});
      a.href = window.URL.createObjectURL(blob);
      a.download = filename;
      a.click();
    },
    persist() {
      localStorage.batchSearch = this.batchSearch ? 1 : 0
      localStorage.useTwitchPlayer = this.useTwitchPlayer ? 1 : 0
      localStorage.useSearchGrid = this.useSearchGrid ? 1 : 0
      localStorage.showId = this.showId ? 1 : 0
      localStorage.videoUserData = this.videoUserData
    },
    search: function(e) {
      e.preventDefault()
      if(this.$refs.search.validate()) {
        this.$router.push({params: {channelName: this.user}})
        this.fetchData()
      }
    },
    fetchData () {
      this.isLoaded = false
      this.selectedGame = [],
      this.selectedAuthors = []

      //var toDate = encodeURIComponent(new dayjs(this.toDate).endOf('day').format());
      //var fromDate = encodeURIComponent(new dayjs(this.fromDate).format());

      let dates = []
      let from = new dayjs(this.fromDate)
      let to =  new dayjs(this.toDate)
      let type = this.selectedBroadcastType.toLowerCase()

      if(this.batchSearch){
        let dayBatchSize = 31

        let toBatch = new dayjs(this.fromDate)
        let fromBatch = new dayjs(this.fromDate)

        do {
          toBatch = toBatch.add(dayBatchSize, 'day')
          if(toBatch.isAfter(to)){toBatch = to}
          dates.push({to: toBatch.endOf('day').format(), from: fromBatch.format()})
          fromBatch = toBatch.add(1, 'day')
        } while(toBatch.isBefore(to))        
      } 
      else{
        dates.push({to: to.endOf('day').format(), from: from.format()})
      }

      this.twitch.GetUserId(this.user).then(id => {
        this.twitch.GetVideos(id, type, this.$root.$data.token).then(v => {
            this.videos = v.map(video => {
              video.thumbnail_url = video.thumbnail_url.replace('%{width}', '1280').replace('%{height}', '720')
              return video
            })
            // var games = this.uniqBy(this.videos.map(v => v.game), 'id')
            // this.games = games.concat().sort(this.sortBy('name'));
            this.authors = [...new Set(this.videos.map(v => v.creator_name))].sort()

            this.isLoaded = true
            this.$ga.event({
              eventCategory: 'Video',
              eventAction: 'Search',
              eventLabel: this.user
            })
        }).catch(this.errorHandle)
      }).catch(this.errorHandle)
    },
    uniqBy: function(arr, predicate)  {
      const cb = typeof predicate === 'function' ? predicate : (o) => o[predicate];
      return [...arr.reduce((map, item) => {
        const key = cb(item);       
        map.has(key) || map.set(key, item);
        return map;
      }, new Map()).values()];
    },
    sortBy: function(key) {
      return (a, b) => (a[key] > b[key]) ? 1 : ((b[key] > a[key]) ? -1 : 0)
    },
    errorHandle(e) {
      this.isLoaded = true

      try { 
        let error = JSON.parse(e.message)
        if(error.status == 401){
          localStorage.removeItem('token')
          this.$root.$data.token = null
          this.$root.$data.isLoggedIn = false
          this.isLoggedIn = false
        }
        this.$emit('errorUpdate', error.message) 
      }
      catch {this.$emit('errorUpdate', e) }
    }
  }
}
</script>

<style scoped>
  .custom-loader {
    animation: loader 1s infinite;
    display: flex;
  }

  @-moz-keyframes loader {
    from { transform: rotate(0); }
    to { transform: rotate(360deg); }
  }

  @-webkit-keyframes loader {
    from { transform: rotate(0); }
    to { transform: rotate(360deg); }
  }

  @-o-keyframes loader {
    from { transform: rotate(0); }
    to { transform: rotate(360deg); }
  }

  @keyframes loader {
    from { transform: rotate(0); }
    to { transform: rotate(360deg); }
  }
</style>